import type { SimplePaletteColorOptions } from '@mui/material';

export const aiColor: SimplePaletteColorOptions = {
  main: '#651AC0',
};

export const darkAiColor: SimplePaletteColorOptions = {
  main: '#C4A1FF',
};
